import { Sort } from './sort.data';
import { Customer } from './customer';
import { Box } from './box';

export interface PentestScanPageRequest {
  page?: number;
  size?: number;
  sort?: Sort;
  searchText?: string;
  box?: Box | null;
  id?: string[] | null;
  launchedAtAfter?: Date;
  launchedAtBefore?: Date;
  completedAtAfter?: Date;
  completedAtBefore?: Date;
}

export namespace PentestScanPageRequest {
  export function mapToQuery({
    page,
    size,
    searchText,
    sort,
    box,
    id,
    completedAtBefore,
    launchedAtBefore,
    launchedAtAfter,
    completedAtAfter,
  }: PentestScanPageRequest): any {
    return {
      page,
      size,
      ...(searchText && { textSearch: searchText }),
      ...(sort?.sortBy && sort?.direction && { sort: Sort.mapToQueryParam(sort) }),
      ...(box && { boxId: box.id }),
      ...(id && { id: id.join(',') }),
      ...(completedAtBefore && { completedAtBefore }),
      ...(launchedAtBefore && { launchedAtBefore }),
      ...(launchedAtAfter && { launchedAtAfter }),
      ...(completedAtAfter && { completedAtAfter }),
    };
  }
}
